import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const CallDropped: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_958_1663)">
        <path
          d="M10.4443 1.37402V2.20226C10.4443 3.76401 10.4443 4.54488 10.9295 5.03005C11.4147 5.51522 12.1956 5.51522 13.7573 5.51522H14.9997M14.9997 5.51522L12.9291 3.85874M14.9997 5.51522L12.9291 7.17171"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33456 2.46413L6.8721 3.42731C7.3572 4.29654 7.16246 5.43681 6.39844 6.20084C6.39843 6.20084 6.39844 6.20084 6.39843 6.20085C6.39829 6.20099 5.47182 7.12773 7.15197 8.80788C8.83131 10.4872 9.758 9.56243 9.75901 9.56142C9.75904 9.56139 9.75902 9.56141 9.75905 9.56137C10.5231 8.79738 11.6633 8.60266 12.5325 9.08775L13.4957 9.62529C14.8083 10.3578 14.9633 12.1985 13.8096 13.3522C13.1163 14.0454 12.2671 14.5849 11.3283 14.6204C9.74789 14.6804 7.06398 14.2804 4.37172 11.5881C1.67947 8.89587 1.2795 6.21196 1.33941 4.63157C1.375 3.69277 1.91442 2.84352 2.60766 2.15028C3.76135 0.996579 5.60205 1.15159 6.33456 2.46413Z"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_958_1663">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CallDropped
